import sgd from '../../../../../assets/images/flags/sgd.svg';
import idr from '../../../../../assets/images/flags/idr.svg';
import myr from '../../../../../assets/images/flags/myr.svg';
import thb from '../../../../../assets/images/flags/thb.svg';
import vnd from '../../../../../assets/images/flags/vnd.svg';
import khr from '../../../../../assets/images/flags/khr.svg';
import mmk from '../../../../../assets/images/flags/mmk.svg';

export type PreferencesKeys =
    | 'investmentTypes'
    | 'investmentHorizon'
    | 'riskPreference'
    | 'geographies'
    | 'sectors'
    | 'ticketSize';

export const investmentPreferencesList: {
    step: number;
    data: {
        headText: string;
        type: PreferencesKeys;
        iDontKnow: boolean;
        selectAll: boolean;
        list: {
            html: string;
            value: string;
            img?: string;
        }[];
    }[];
}[] = [
    {
        step: 1,
        data: [
            {
                headText: 'Which type(s) of investments interest you? (Multiple choice)',
                type: 'investmentTypes',
                iDontKnow: true,
                selectAll: true,
                list: [
                    { html: '<p>Private Credit</p>', value: 'Private Credit' },
                    { html: '<p>Private Equity</p>', value: 'Private Equity' },
                    { html: '<p>Diversified Funds</p>', value: 'Diversified Funds' },
                    { html: '<p>Venture Capital</p>', value: 'Venture Capital' },
                    { html: '<p>Impact Investing</p>', value: 'Impact Investing' },
                    { html: '<p>Hedge Funds</p>', value: 'Hedge Funds' },
                    { html: '<p>Real Estate</p>', value: 'Real Estate' },
                    { html: '<p>Cryptocurrencies</p>', value: 'Cryptocurrencies' },
                    { html: '<p>Natural Resources</p>', value: 'Natural Resources' },
                    { html: '<p>Infrastructure</p>', value: 'Infrastructure' },
                ],
            },
        ],
    },
    {
        step: 2,
        data: [
            {
                headText: 'Which investment horizon are you looking at?',
                type: 'investmentHorizon',
                iDontKnow: false,
                selectAll: false,
                list: [
                    { html: '< 1 year', value: '< 1 year' },
                    { html: '1 - 3 years', value: '1 - 3 years' },
                    { html: '3 - 5 years', value: '3 - 5 years' },
                    { html: '> 5 years', value: '> 5 years' },
                ],
            },
            {
                headText: 'Product Risk Preference:',
                type: 'riskPreference',
                iDontKnow: false,
                selectAll: false,
                list: [
                    { html: '<p>Low Risk <br /> (~5% p.a. returns)</p>', value: 'Low Risk (~5% p.a. returns)' },
                    { html: 'Medium Risk <br />(~10% p.a. returns)', value: 'Medium Risk (~10% p.a. returns)' },
                    { html: 'High Risk <br/> (~15% p.a. returns)', value: 'High Risk (~15% p.a. returns)' },
                ],
            },
        ],
    },
    {
        step: 3,
        data: [
            {
                headText: 'Which investment ticket size(s) are you contemplating? (Multiple choice)',
                type: 'ticketSize',
                iDontKnow: false,
                selectAll: true,
                list: [
                    { html: 'Up to USD 100K', value: 'Up to USD 100K' },
                    { html: 'USD 100K to USD 500K', value: 'USD 100K to USD 500K' },
                    { html: 'USD 500K to USD 1M', value: 'USD 500K to USD 1M' },
                    { html: 'USD 1M to USD 5M', value: 'USD 1M to USD 5M' },
                    { html: 'USD 5M to USD 10M', value: 'USD 5M to USD 10M' },
                    { html: 'USD 10M to USD 20M', value: 'USD 10M to USD 20M' },
                    { html: 'USD 20M to USD 30M', value: 'USD 20M to USD 30M' },
                    { html: '> USD 30M', value: '> USD 30M' },
                ],
            },
        ],
    },
    {
        step: 4,
        data: [
            {
                headText: 'Which geographies are you looking to invest in? (Multiple choice)',
                type: 'geographies',
                iDontKnow: false,
                selectAll: true,
                list: [
                    { html: `Singapore`, value: 'Singapore', img: sgd },
                    { html: `Indonesia`, value: 'Indonesia', img: idr },
                    { html: `Malaysia`, value: 'Malaysia', img: myr },
                    { html: `Thailand`, value: 'Thailand', img: thb },
                    { html: `Vietnam`, value: 'Vietnam', img: vnd },
                    { html: 'Cambodia', value: 'Cambodia', img: khr },
                    { html: 'Philippines', value: 'Philippines', img: mmk },
                    { html: 'All Southeast Asia', value: 'All Southeast Asia' },
                    { html: 'South Asia', value: 'South Asia' },
                    { html: 'Central Asia', value: 'Central Asia' },
                    { html: 'East Asia', value: 'East Asia' },
                    { html: 'Oceania', value: 'Oceania' },
                ],
            },
        ],
    },
    {
        step: 5,
        data: [
            {
                headText: 'Which sectors are you looking to invest in? (Multiple choice)',
                type: 'sectors',
                iDontKnow: false,
                selectAll: true,
                list: [
                    { html: 'Agriculture', value: 'Agriculture' },
                    { html: 'Commodities', value: 'Commodities' },
                    { html: 'Consumer Discretionary', value: 'Consumer Discretionary' },
                    { html: 'Consumer Staples', value: 'Consumer Staples' },
                    { html: 'Energy - Alternative', value: 'Energy - Alternative' },
                    { html: 'Energy - Conventional', value: 'Energy - Conventional' },
                    { html: 'Financial Services', value: 'Financial Services' },
                    { html: 'Financial Technology', value: 'Financial Technology' },
                    { html: 'Food & Beverage', value: 'Food & Beverage' },
                    { html: 'Healthcare', value: 'Healthcare' },
                    { html: 'Impact Investments', value: 'Impact Investments' },
                    { html: 'Industrial & Materials', value: 'Industrial & Materials' },
                    { html: 'Information Technology', value: 'Information Technology' },
                    { html: 'Professional Services', value: 'Professional Services' },
                    { html: 'Real Estate', value: 'Real Estate' },
                    {
                        html: 'Telecommunications, Media and Entertainment',
                        value: 'Telecommunications, Media and Entertainment',
                    },
                    { html: 'Transportation & Logistics', value: 'Transportation & Logistics' },
                    { html: 'Others', value: 'Others' },
                ],
            },
        ],
    },
];
